"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleAccount = /** @class */ (function () {
    /**
     *
     * @param base_account
     * @param name
     * @param permissions
     */
    function ModuleAccount(base_account, name, permissions) {
        this.base_account = base_account;
        this.name = name;
        this.permissions = permissions;
    }
    /**
     *
     * @param value
     */
    ModuleAccount.fromJSON = function (value) {
        return new ModuleAccount(value.base_account, value.name, value.permissions);
    };
    return ModuleAccount;
}());
exports.ModuleAccount = ModuleAccount;
